export default {
  title: 'Razlog obiska',
  add: 'Dodajte razlog obiska',
  change: 'Spremenite razlog obiska',
  filter: 'Razlogi obiskov'
};
